import MainLogoCompany from './container'
export { MainLogoCompany }
export default MainLogoCompany